import { type ReactNode } from "react";

import { Tag as RATag, type TagProps as RATagProps } from "react-aria-components";

import { Button } from "#components/Button";
import { tagStyles, type TagColor } from "#components/shared/tagVariants";
import { ClearIcon } from "#icons";
import { cn } from "#utils";

export type { TagColor };

export interface TagProps extends Omit<RATagProps, "children"> {
  children: ReactNode;
  icon?: ReactNode;
  color?: TagColor;
  className?: string;
}

export function Tag({ children, icon, color = "indigo", className, ...props }: TagProps) {
  const textValue = typeof children === "string" ? children : undefined;
  return (
    <RATag
      className={tagStyles({
        color,
        className: cn("mr-1", className),
      })}
      textValue={textValue}
      {...props}
    >
      {({ allowsRemoving }) => (
        <>
          {icon ? <span className="mr-0.5 inline-flex items-center">{icon}</span> : null}
          {children}
          {allowsRemoving ? (
            <Button
              IconLeft={<ClearIcon />}
              className="border-none p-0 text-inherit outline-none"
              slot="remove"
              variant="plain"
            />
          ) : null}
        </>
      )}
    </RATag>
  );
}
